import React from 'react'
import { Link } from 'react-router-dom'
import { useStyles } from './back-link.style'

export const BackLink = function ({ to, label = 'Back', className = '', onClick = () => {} }) {
  const classes = useStyles()
  return (
    <React.Fragment>
      {to
        ? <Link to={to} className={`${classes.backLink} flex-row undecorated-link ${className}`}>
          <span className={classes.backIcon} />
          <span className={classes.backText}>{label}</span>
        </Link>
        : <a className={`${classes.backLink} ${classes.hoverAnchor} flex-row undecorated-link`}
          onClick={onClick}>
          <span className={classes.backIcon}></span>
          <span className={classes.backText}>{label}</span>
        </a>}
    </React.Fragment>
  )
}
